// 言語コード → 国コードの対応（必要に応じて拡張）
// 中国語は台湾・香港のマーケットが無いため日本のままにする
const LANGUAGE_TO_COUNTRY = {
  en: 'US',
  ja: 'JP',
  'zh-CN': 'JP',
  'zh-TW': 'JP',
};

// いま選べる国（マーケットが有効な国）。snippets/locale-country-sync.liquid が出力する
function getAvailableCountries() {
  const el = document.getElementById('LocaleCountrySyncAvailable');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

// Hextom（翻訳アプリ）は、覚えている地域と画面の国が違うとページ読み込み時に国を戻す。
// テーマで国を切り替えるときは、Hextom が覚えている地域と言語も同じ値にしておく
const HEXTOM_STATE_KEY = 'tms-selector-state-storage';

function syncHextomState(locale, country) {
  try {
    const raw = localStorage.getItem(HEXTOM_STATE_KEY);
    const state = raw ? JSON.parse(raw) : {};
    if (!state || typeof state !== 'object') return;
    state.tms_target_region = country;
    state.tms_target_language = locale;
    state.tms_is_change_valid = true;
    localStorage.setItem(HEXTOM_STATE_KEY, JSON.stringify(state));
  } catch (e) {
    // 保存できない環境では何もしない
  }
}

function applyLocaleCountry(locale) {
  let country = LANGUAGE_TO_COUNTRY[locale] || 'JP';
  const available = getAvailableCountries();
  if (available && !available.includes(country)) country = 'JP';

  const form = document.getElementById('LocaleCountrySyncForm');
  if (!form) return;

  const localeInput = form.querySelector('input[name="locale_code"]');
  const countryInput = form.querySelector('input[name="country_code"]');
  if (localeInput) localeInput.value = locale;
  if (countryInput) countryInput.value = country;

  syncHextomState(locale, country);
  form.submit();
}

function isLocaleCountrySyncForm(form) {
  return form instanceof HTMLFormElement && form.id === 'LocaleCountrySyncForm';
}

function isThemeLocalizationForm(form) {
  return form instanceof HTMLFormElement && form.querySelector('button[name="locale_code"], button[name="country_code"]');
}

// 言語セレクター: locale と country を同時に POST（ja=JP / en=US / 中国語=JP）
document.addEventListener('click', (event) => {
  const localeButton = event.target.closest('button[name="locale_code"]');
  if (!localeButton) return;

  const form = localeButton.closest('form');
  if (!form || isLocaleCountrySyncForm(form)) return;
  if (!isThemeLocalizationForm(form)) return;

  event.preventDefault();
  applyLocaleCountry(localeButton.value);
});

// 旧実装との互換（data-locale-select / data-locale-link）
document.addEventListener('change', (event) => {
  const target = event.target.closest('[data-locale-select]');
  if (!target) return;

  const locale = target.value || target.getAttribute('data-locale');
  if (locale) applyLocaleCountry(locale);
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-locale-link]');
  if (!link) return;

  const locale = link.getAttribute('data-locale');
  if (!locale) return;

  event.preventDefault();
  applyLocaleCountry(locale);
});
